<template>
  <div class="date-component" @click.stop.prevent :style="getTextStyle">
    <div class="verticallyCenter" ref="textInner" :style="getTextColor">
      {{ getDateContent }}
      {{ getWeekContent }}
      {{ getLunarContent }}
      {{ getSolarTermContent }}
    </div>
  </div>
</template>

<script>
import eventMixin from "utils/event/eventMixin.js"
import {getLunar} from 'chinese-lunar-calendar'
import dataRenderMixin from "materials/dataRenderMixin"
export default {
  mixins: [eventMixin, dataRenderMixin],
  name: "cxDate",
  props: {
    options: {
      type: Object,
      default: null
    },
    myid: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      newDate: "",
      timer: "",
      hour: "",
      minute: "",
      second: "",
      year: "",
      month: "",
      day: "",
      updateDate: false
    }
  },
  watch: {
    updateDate(n, o) {
      if (this.isBigScreenPreview()) {
        if (this.date && n) {
          this.getValue()
          this.countTimer()
          this.updateDate = false
        }
      }
    }
  },
  created() {
    if (!this.isBigScreenPreview()) {
      this.getDate()
    }
  },
  mounted() {
    if (this.$refs.textInner) {
      this.$refs.textInner.style.transform = "rotate(" + this.options.rotate + "deg)"
    }
    // 解决浏览器切换页面tab后，计时偏慢问题
    window.addEventListener("visibilitychange", this.handleTimer)
  },
  beforeDestroy() {
    window.removeEventListener("visibilitychange", this.handleTimer)
    clearInterval(this.timer)
  },
  computed: {
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    date: {
      get() {
        if (this.isBigScreenPreview()) {
          let weatherAndDate = this.$store.state.states.weatherAndDate
          if (weatherAndDate) {
            this.updateDate = true
          }
          return weatherAndDate
        } else {
          return this.newDate
        }
      }
    },
    getDateContent() {
      let showDate = ""
      if (!this.date || !this.date.dateTime) {
        return showDate
      }
      // if(typeof this.month === 'string'){
      //   this.getValue()
      //   this.countTimer()
      //   this.updateDate = false
      // }
      let month = this.month < 10 ? "0" + this.month : this.month
      let day = this.day < 10 ? "0" + this.day : this.day
      let hour = this.hour < 10 ? "0" + this.hour : this.hour
      let minute = this.minute < 10 ? "0" + this.minute : this.minute
      let second = this.second < 10 ? "0" + this.second : this.second
      switch (this.options.dateStyle) {
        case "1":
          // "2021年11月24日"
          showDate = `${this.year}年${month}月${day}日`
          break
        case "2":
          // "2021年11月24日 12时00分00秒"
          showDate = `${this.year}年${month}月${day}日 ${hour}时${minute}分${second}秒`
          break
        case "3":
          // "2021-11-24"
          showDate = `${this.year}-${month}-${day}`
          break
        case "4":
          // "2021-11-24 12:00:00"
          showDate = `${this.year}-${month}-${day} ${hour}:${minute}:${second}`
          break
        case "5":
          // "2021/11/24"
          showDate = `${this.year}/${month}/${day}`
          break
        case "6":
          // "2021/11/24 12:00:00"
          showDate = `${this.year}/${month}/${day} ${hour}:${minute}:${second}`
          break
        case "7":
          // "12:00:00"
          showDate = `${hour}:${minute}:${second}`
          break
        default:
      }
      return showDate
    },
    getWeekContent() {
      let showWeek = ""
      if (!this.date || !this.options.dateStyle) {
        return showWeek
      }
      switch (this.options.weekStyle) {
        case "1":
          // 不显示
          break
        case "2":
          // 星期一
          showWeek = this.date.day
          break
        case "3":
          // 周一
          showWeek = this.date.day.replace("星期", "周")
          break
        default:
      }
      return showWeek
    },
    getTextColor() {
      let colorStyle = {}
      if (this.options.colorType === "线性渐变") {
        colorStyle = {
          color: "transparent",
          "background-image":
            `linear-gradient(90deg,${this.$parseColor(this.options.startColor)},${this.$parseColor(this.options.endColor)})`,
          "-webkit-background-clip": "text",
          "-webkit-line-clamp": this.options.textLimitLines
        }
      } else {
        colorStyle = {
          // color: this.options.textIsThemeColor ? this.themeColor : this.options.color,
          color: this.$parseColor(this.options.color, {
            isThemeColor: this.options.textIsThemeColor
          }),
          "-webkit-line-clamp": this.options.textLimitLines
        }
      }
      return colorStyle
    },
    getTextStyle() {
      if (this.$refs.textInner) {
        this.$refs.textInner.style.transform = "rotate(" + this.options.rotate + "deg)"
        this.$refs.textInner.style.background = this.bgColor
      }
      const lineHeight = this.options.lineHeightType === '%' ? (this.options.lineHeight / 100) :
          this.options.lineHeightType === 'normal'? "normal" :this.options.lineHeight + "px"
      return {
        "font-Family": this.options.fontFamily,
        "font-size": this.options.fontSize + "px",
        "font-weight": this.options.fontWeight,
        // "line-height": this.options.lineHeight + "px",
        "line-height": lineHeight,
        "font-style": this.options.fontStyle,
        "text-indent": this.options.textIndent,
        "text-align": this.options.textAlign,
        "writing-mode": this.options.writingMode,
        // "letter-spacing": this.options.letterSpacing + "px",
        "letter-spacing":
          this.options.letterSpacingType === "%"
            ? this.options.letterSpacing / 100 + "em"
            : this.options.letterSpacing + "px",
        "text-decoration": this.options.textDecoration,
        // "text-decoration-color": this.options.color,
        "text-decoration-color": this.$parseColor(this.options.color, {
          isThemeColor: this.options.textIsThemeColor
        }),
        top: this.options.top,
        left: this.options.left
      }
    },
    getLunarContent() {
    //  获取农历内容
      let lunarStr = ""
      if (!this.date || !this.options.showLunar) {
        return lunarStr
      }
      const lunarInfo = getLunar(this.year, this.month, this.day)
      lunarStr = lunarInfo.lunarYear + lunarInfo.dateStr
      return lunarStr
    },
    getSolarTermContent() {
      //  获取节气内容
      let solarTermStr = ""
      if (!this.date || !this.options.showSolarTerms) {
        return solarTermStr
      }
      const lunarInfo = getLunar(this.year, this.month, this.day)
      solarTermStr = lunarInfo.solarTerm
      return solarTermStr
    }
  },
  methods: {
    countTimer(newDate) {
      let newData = newDate || this.date
      clearInterval(this.timer)
      // if (!this.date  || !this.options.dateStyle) {
      //   return
      // }
      if (!newData || !this.options.dateStyle) {
        return
      }
      this.timer = setInterval(() => {
        // console.log('countTimer',this.second)
        this.second = this.second < 59 ? this.second + 1 : 0
        this.minute = this.second === 0 ? (this.minute < 59 ? this.minute + 1 : 0) : this.minute
        this.hour = this.minute === 0 && this.second === 0 ? (this.hour < 23 ? this.hour + 1 : 0) : this.hour
        if (this.hour === 23 && this.minute === 59 && this.second === 59) {
          this.getDate()
        }
        if (this.hour === 7 && this.minute === 0 && this.second === 0) {
          window.location.reload()
        }
      }, 1000)
    },
    // 获取日期
    async getDate() {
      let res = await this.instance.get(`engine2/weather/today-v3`)
      if (res.data.code === 1) {
        clearInterval(this.timer)
        this.newDate = res.data.data
        this.$store.commit("states/changeGeneralAttr", {
          valName: "weatherAndDate",
          val: this.newDate
        })
        this.getValue(this.newDate)
        this.countTimer()
      }
    },
    getValue(newDate) {
      let newData = newDate || this.date
      if (!newData || JSON.stringify(newData) === "{}") {
        return
      }
      // if(!this.date){
      //   return
      // }
      let dateTime = newData.dateTime
      let date = dateTime.split(" ")[0]
      let time = dateTime.split(" ")[1]

      this.hour = parseInt(time.split(":")[0])
      this.minute = parseInt(time.split(":")[1])
      this.second = parseInt(time.split(":")[2])

      this.year = parseInt(date.split("-")[0])
      this.month = parseInt(date.split("-")[1])
      this.day = parseInt(date.split("-")[2])
    },
    handleTimer() {
      if (!document.hidden) {
        clearInterval(this.timer)
        this.getDate()
      }
    }
  }
}
</script>

<style scoped>
.overflowHidMultiLines {
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.date-component,
.date-component > div {
  transition: transform 0.5s;
}
.date-component > div {
  pointer-events: none;
  display: inline-block;
}
</style>
